import React from "react";
import "./Common_Title.css";

const Common_Title = ({ pageTitle, boxText, subText,darkText,simpleText }) => {
  return (
    <div className="Common_Title">
      {pageTitle && <p className="page_title">{pageTitle}</p>}
      {boxText && <p className="box_text">{boxText}</p>}
      {subText && <p className="sub_text">{subText}</p>}

      <div className="text_content">
        <p className="dark_text">{darkText}</p>
        <p className="simple_text">{simpleText}</p>
      </div>
    </div>
  );
};

export default Common_Title;
